import dynamic from 'next/dynamic'

export default dynamic(() => import('./DialogProvider'), {
  ssr: false,
})
